module.exports = __webpack_public_path__ + "static/media/icon-straight.6dc8b206.svg";